var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListaDeVerificacion1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4585 6.9043H12.4597V9.168H18.4585V6.9043Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27304 25.58V3.39556C2.27304 2.77143 2.78076 2.2637 3.40489 2.2637H19.5841C20.2083 2.2637 20.716 2.77143 20.716 3.39556V14.4833L22.9797 12.1556V3.39556C22.9797 1.52324 21.4565 0 19.5841 0H3.40489C1.53257 0 0.00927734 1.52324 0.00927734 3.39556V25.58C0.00927734 27.4523 1.53252 28.9755 3.40483 28.9755H12.0463L12.561 26.7118H3.40489C2.78076 26.7118 2.27304 26.2041 2.27304 25.58Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4585 13.6956H12.4597V15.9593H18.4585V13.6956Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1703 14.1783L16.5653 21.9983C16.1307 22.4346 15.7987 22.974 15.6051 23.5585L15.5879 23.6103L14.3623 29L19.7663 27.7902L19.8198 27.7725C20.4073 27.5781 20.9492 27.2441 21.3868 26.8067L28.9908 18.9881L24.1703 14.1783ZM19.7817 25.2105C19.7394 25.2525 19.6947 25.2921 19.6482 25.3294L18.0495 23.7296C18.0878 23.682 18.1286 23.6363 18.1718 23.5932L24.1946 17.4004L25.8098 19.012L19.7817 25.2105Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2527 11.3623L7.48249 14.5043L6.10402 13.2099L4.55444 14.8602L7.6357 17.7536L11.9507 12.8594L10.2527 11.3623Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2527 4.51453L7.48249 7.65656L6.10402 6.36209L4.55444 8.01232L7.6357 10.9058L11.9507 6.0116L10.2527 4.51453Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10402 20.0011L4.55444 21.6514L7.6357 24.5448L11.9507 19.6506L10.2527 18.1536L7.48249 21.2956L6.10402 20.0011Z",
    fill: "#404041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaDeVerificacion1);
export default __webpack_public_path__ + "static/media/lista-de-verificacion 1.91db3821fe91f735da24bdfd33028576.svg";
export { ForwardRef as ReactComponent };